/** Deutsch */
export default {
  common: {
    loading: 'Wird geladen…',
    loadingProject: 'Projekt wird geladen…',
    cancel: 'Abbrechen',
    optional: '(optional)',
    you: 'Sie',
    dash: '—',
    serverError: 'Fehler {{status}}',
  },
  lang: {
    label: 'Sprache',
  },
  nav: {
    projects: 'Projekte',
    tecnico: 'Technisches Büro',
    admin: 'Verwaltung',
    logout: 'Abmelden',
  },
  roles: {
    USER: 'Benutzer',
    TECNICO: 'Techniker',
    ADMIN: 'Admin',
    badgeAdmin: 'admin',
    badgeTecnico: 'techniker',
  },
  craneType: {
    CINGOLATA: 'Raupenkran',
    RAGNO: 'Spinnenkran',
    AUTOCARRATA: 'LKW-Kran',
    TORRE: 'Turmkran',
  },
  login: {
    titleLogin: 'Beim Konfigurator anmelden',
    titleRegister: 'Konto erstellen',
    subtitle: 'BGLift 3D-Krankonfigurator',
    name: 'Name',
    email: 'E-Mail',
    password: 'Passwort',
    submitLogin: 'Anmelden',
    submitRegister: 'Registrieren',
    toggleToRegister: 'Noch kein Konto? Registrieren',
    toggleToLogin: 'Bereits ein Konto? Anmelden',
  },
  dashboard: {
    title: 'Ihre Projekte',
    subtitle: 'Gespeicherte Hebekonfigurationen',
    newProject: '+ Neues Projekt',
    empty: 'Noch keine Projekte: Erstellen Sie eines, um mit der Konfiguration des Krans zu beginnen.',
    createFirst: 'Erstes Projekt erstellen',
    byUser: 'von {{name}}',
    updated: 'Aktualisiert am {{date}}',
    certificatePdf: 'PDF-Zertifikat',
    resend: 'Erneut zur Freigabe senden',
    sendForReview: 'Zur technischen Freigabe senden',
    openConfigurator: 'Konfigurator öffnen',
    deleteTitle: 'Projekt löschen',
    confirmDelete: 'Projekt „{{name}}“ löschen?',
    modalTitle: 'Neues Projekt',
    modalSubtitle: 'Wählen Sie Krantyp und -modell: Sie konfigurieren ihn in der 3D-Szene.',
    projectName: 'Projektname',
    projectNamePlaceholder: 'z. B. Baustelle Via Roma',
    craneType: 'Krantyp',
    selectType: 'Typ auswählen…',
    model: 'Modell',
    selectModel: 'Modell auswählen…',
    createProject: 'Projekt erstellen',
    creating: 'Wird erstellt…',
  },
  configurator: {
    backToProjects: 'Zurück zu den Projekten',
    back: 'Projekte',
    savedAt: 'Gespeichert um {{time}}',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
  },
  tecnico: {
    title: 'Technisches Büro',
    subtitle: 'Freigabeanfragen für Konfigurationen von Kunden',
    empty: 'Keine Anfragen in der Warteschlange. Neue Kundenanfragen erscheinen hier.',
    requestedBy: 'Anfrage von {{name}} ({{email}}) · gesendet am {{date}}',
    assignedTo: 'Zugewiesen an {{name}}',
    openConfiguration: 'Konfiguration öffnen',
    claim: 'Übernehmen',
    certify: 'PDF anhängen und zertifizieren',
    certifying: 'Wird hochgeladen…',
  },
  admin: {
    title: 'Verwaltung',
    subtitle: 'Benutzer und Katalog der Kranmodelle verwalten',
    tabUsers: 'Benutzer',
    tabModels: 'Kranmodelle',
  },
  users: {
    newUser: '+ Neuer Benutzer',
    colUser: 'Benutzer',
    colRole: 'Rolle',
    colStatus: 'Status',
    colProjects: 'Projekte',
    colActions: 'Aktionen',
    active: 'Aktiv',
    inactive: 'Deaktiviert',
    resetPassword: 'Passwort zurücksetzen',
    deactivate: 'Deaktivieren',
    reactivate: 'Reaktivieren',
    delete: 'Löschen',
    modalTitle: 'Neuer Benutzer',
    name: 'Name',
    email: 'E-Mail',
    password: 'Passwort',
    role: 'Rolle',
    createUser: 'Benutzer erstellen',
    creating: 'Wird erstellt…',
    promptResetPassword: 'Neues Passwort für {{email}} (mind. 6 Zeichen):',
    passwordUpdated: 'Passwort aktualisiert.',
    confirmDelete: '{{email}} endgültig löschen? Die {{count}} zugehörigen Projekte werden ebenfalls gelöscht.',
  },
  models: {
    newModel: '+ Neues Modell',
    colCode: 'Code',
    colName: 'Name',
    colType: 'Typ',
    colFile3d: '3D-Datei',
    colProjects: 'Projekte',
    colStatus: 'Status',
    colActions: 'Aktionen',
    active: 'Aktiv',
    inactive: 'Deaktiviert',
    deactivate: 'Deaktivieren',
    activate: 'Aktivieren',
    delete: 'Löschen',
    confirmDelete: 'Modell {{code}} löschen?',
    modalTitle: 'Neues Kranmodell',
    modalSubtitle:
      'Sie benötigen die 3D-Datei (.glb) und die JSON-Datei mit den technischen Daten (Geometrie, Lasttabelle, Standardkonfiguration — dieselbe Struktur wie BR0089.json).',
    code: 'Code',
    codePlaceholder: 'z. B. BR0100',
    craneType: 'Krantyp',
    name: 'Name',
    namePlaceholder: 'z. B. BGLift BR0100',
    description: 'Beschreibung',
    file3d: '3D-Datei (.glb)',
    dataFile: 'Technische Daten (.json)',
    createModel: 'Modell erstellen',
    creating: 'Wird hochgeladen…',
  },
  controls: {
    realtimeCalc: 'Echtzeit-Tragfähigkeitsberechnung',
    reset: 'Zurücksetzen',
    resetField: 'Zurücksetzen',
    restore: 'Wiederherstellen',
    legFrontLeft: 'Vorne links',
    legFrontRight: 'Vorne rechts',
    legRearLeft: 'Hinten links',
    legRearRight: 'Hinten rechts',
    groupLoad: 'Last',
    loadWeight: 'Gehobenes Gewicht',
    maxSwl: 'Max. Tragfähigkeit (SWL)',
    loadUtil: 'Lastauslastung',
    groupAerial: 'Oberer Baugruppe',
    boom: 'Ausleger',
    angle: 'Winkel',
    extensionStroke: 'Ausschubhub',
    borePressure: 'Bodendruck',
    rodPressure: 'Stangendruck',
    turretRotation: 'Oberwagendrehung',
    workRadius: 'Arbeitsradius',
    jib: 'Jib',
    jibAngle: 'Jib-Winkel',
    groupGround: 'Bodengruppe',
    opening: 'Öffnung',
    footHeight: 'Fußhöhe',
    knee: 'Knie',
    groundHelp:
      'Öffnung und Knie haben feste Positionen (Bohrungen an der Maschine), einzeln je Abstützung einstellbar: Öffnung 0° = entlang des Fahrwerks eingeklappt, {{deg}}° = vollständig geöffnet; Knie 0° = Stützbein in Konstruktionslage. Fußhöhe: 0 = Fuß am Boden, positive Werte = Fuß auf einer höheren Auflage (weiterhin aufliegend und tragend). Die Reaktionen verwenden die realen Fußpositionen aus Öffnung, Knie und Fußhöhe (Geometrie aus der BGLift-Zeichnung); die Maschinenmassen bleiben Richtwerte.',
    disclaimer:
      'Prototyp mit indikativen SWL-Daten. Vor dem Einsatz auf der Baustelle stets mit der offiziellen BGLift-Tabelle und der Norm EN 13000 abgleichen.',
  },
  status: {
    safe: 'SICHER',
    warning: 'ACHTUNG',
    critical: 'KRITISCH — STOPP',
    shortSafe: 'OK',
    shortWarning: 'ACHT.',
    shortCritical: 'STOPP',
    calculating: 'Berechnung läuft…',
    radius: 'Radius',
    swl: 'SWL',
    loadUtil: 'Lastausl.',
    padUtil: 'Max. Plattenausl.',
    tippingMargin: 'Kippsicherheitsmarge',
    en13000: 'EN 13000 — Kippen bei 0 % · Warnschwelle bei 20 %',
    controls: 'Steuerung',
  },
  review: {
    requested: 'An das technische Büro gesendet',
    inReview: 'Vom technischen Büro übernommen',
    certified: 'Konfiguration zertifiziert',
    certificatePdf: 'PDF-Zertifikat',
    sending: 'Wird gesendet…',
    resend: 'Erneut zur Freigabe senden',
    send: 'Zur technischen Freigabe senden',
  },
  crane3d: {
    loading: 'Wird geladen…',
  },
}
